export default __webpack_public_path__ + "static/media/portal.c4fcb296.svg";